import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx';

import './FormElements.scss';

function LeoInput(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		backgroundColor: context.themeManager
			.value('form-element', 'borderColor', 'bg-color-form-element'),
		borderColor: context.themeManager.value(
			'form-element', 'borderColor', 'border-color-form-element'),
		outlineColor: context.themeManager.value(
			'form-element', 'borderColor', 'fg-color-form-element'),
		color: context.themeManager.value('form-element', 'color', 'fg-color-form-element'),
		fontSize: context.themeManager.value('form-element', 'fontSize', 'font-size-100'),
	};

	const infoTextStyle = {
		color: context.themeManager.valueOrDefault('input-info-text', 'color', 'color-input-info', '#b75306'),
		fontWeight: context.themeManager.valueOrDefault('input-info-text', 'fontWeight', null, '600'),
	};

	const errorMsgStyle = {
		color: context.themeManager.valueOrDefault('form-element-errorMsg', 'color', 'color-error', '#e10101'),
		fontWeight: context.themeManager.valueOrDefault('form-element-errorMsg', 'fontWeight', null, '600'),
		padding: '.3em 0 0 0'
	}

	const errStyle = {
		background: context.themeManager.value('form-element', 'borderColor', 'bg-color-form-element'),
		borderColor: context.themeManager.valueOrDefault('form-element-errorMsg', 'borderColor', 'color-error', '#e10101'),
		color: context.themeManager.value('form-element', 'color', 'fg-color-form-element'),
		outlineColor: context.themeManager.valueOrDefault('form-element-errorMsg', 'borderColor', 'color-error', '#e10101'),
	};

	const warnStyle = {
		background: context.themeManager.value('form-element', 'borderColor', 'bg-color-form-element'),
		borderColor: context.themeManager.valueOrDefault('form-element-warnMsg', 'borderColor', 'color-warn', '#b75306'),
		color: context.themeManager.value('form-element', 'color', 'fg-color-form-element'),
		outlineColor: context.themeManager.valueOrDefault('form-element-warnMsg', 'borderColor', 'color-warn', '#b75306'),
	};

	// maxlength fix for android browser
	function checkMaxLength(maxLength, inputValue) {
		return maxLength && inputValue.length > maxLength ? inputValue.substring(0, maxLength) : inputValue;
	}

	function determineStyle() {
		if (props.errors) {
			return errStyle;
		} else if (props.warn) {
			return warnStyle;
		}
		return style;
	}

	if (props.textarea) {
		return (
		<div className={"leo__input-container"}>
			<textarea
				maxLength={props.maxLength}
				id={props.id}
				name={props.name}
				onBlur={props.onBlur}
				value={checkMaxLength(props.maxLength, props.value)}
				onChange={props.onChange}
				placeholder={props.placeholder}
				style={determineStyle()}
				className="leo__textarea"
				aria-label={props.label || props.placeholder}
				aria-invalid={!!props.errors}
				aria-errormessage={"error_" + props.id}
				{ ...(props.infoText ? { 'aria-describedby': props.id + '_info-text' } : {}) }
			/>
			{props.errors &&
				<div id={"error_" + props.id} style={errorMsgStyle}>{
					props.errors.map((error) => error.message)}
				</div>
			}
			{props.infoText &&
				<div className="input__info-text" style={infoTextStyle} id={props.id + '_info-text'}>
					{props.infoText}
				</div>
			}
		</div>
		)
	}

	return (
		<div className={"leo__input-container"}>
			<input
				type={props.type}
				maxLength={props.maxLength}
				id={props.id}
				name={props.name}
				onBlur={props.onBlur}
				value={checkMaxLength(props.maxLength, props.value)}
				onChange={props.onChange}
				placeholder={props.placeholder}
				style={determineStyle()}
				autoComplete={props.autoComplete}
				className="leo__input"
				aria-label={props.label || props.placeholder}
				aria-invalid={!!props.errors}
				aria-errormessage={"error_" + props.id}
				{ ...(props.infoText ? { 'aria-describedby': props.id + '_info-text' } : {}) }
			/>
			{props.errors &&
					<div id={"error_" + props.id} style={errorMsgStyle}>{
						props.errors.map((error) => error.message)}
					</div>
			}
			{props.infoText &&
				<div className="input__info-text" style={infoTextStyle} id={props.id + '_info-text'}>
				{props.infoText}
			</div>
			}
		</div>
	);
}

export default radium(LeoInput);
